<section class="py-4">

  <div class="row mx-2">
    <div class="col-6 col-xl-2 px-3 pb-2">
      <app-date-interval [(inicio)]="dataInicio" [(fim)]="dataFim" (fimChange)="realizarRelatorio()" (inicioChange)="realizarRelatorio()"></app-date-interval>
    </div>
    
    <div class="col-12 col-md-6 col-xl-4 px-3 pb-2">
      <label for="pesquisaConsulta">Cliente</label>
      <div class="d-flex align-items-center autocomplete-container">
        <input [inputFormatter]="inputClienteFormat" (selectItem)="addFiltroCliente($event)" [(ngModel)]="clienteSelecionado" [ngbTypeahead]="pesquisaCliente" [resultTemplate]="rt_cliente"
          id="pesquisaCliente" type="text" class="form-control">
        <button *ngIf="clienteSelecionado" (click)="removeFiltroCliente()" class="btn btn-xs btn-danger btn-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <ng-template #rt_cliente let-r="result" let-t="term">
        <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
      </ng-template>
    </div>

    <div class="col-12 col-md-6 col-xl-4 px-3 pb-2">
      <label for="pesquisaTipo">Tipo</label>
      <select [(ngModel)]="tipoSelecionado" name="" id="pesquisaTipo" class="form-control">
        <option value=""></option>
        <option *ngFor="let o of listaTipo" value="{{o.nome}}">{{o.nome}}</option>
      </select>
    </div>
  </div>



  <div class="d-flex justify-content-between align-items-center m-4">
    <span class="text-muted mr-2 mr-md-4">
      Obs*: Relatório com alta taxa de processamento, utilize os filtros para executar somente o necessário.
    </span>
    <button (click)="realizarRelatorio()" class="btn btn-success btn-icon flex-shrink-0">
      <i class="mdi mdi-file-search-outline"></i>
      <span>Gerar relatório</span>
    </button>
  </div>

  <div *ngIf="tableLoading" class="m-4 card">
    <div *ngIf="tableLoading" class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <ng-container *ngFor="let u of listaResultado">

    <div class="mx-4 my-1 card">
      <div (click)="u.show = !u.show" class="pointer d-flex bg-white align-items-center justify-content-between">
        <div class="px-2 fw-500 f-14">
          {{u.unidade?.nomeFantasia}}
        </div>
        <div class="pr-2 d-none d-lg-block text-nowrap text-muted">
          <span class="fw-500">Consultas (mês/periodo)</span>: {{u.qtdIntervalo1 | number:'0.0-0'}} / {{u.projecaoIntervalo1 | number:'0.0-0'}}
          <span class="fw-500 p-3 pl-xl-5">Projeção mês (anterior/atual)</span>: {{u.qtdIntervalo2 | number:'0.0-0'}} / {{u.projecaoIntervalo2 | number:'0.0-0'}}
        </div>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <span class="text-{{u.crescimento < 0 ? 'danger' : u.crescimento == 0 ? 'warning' : 'success' }} fw-500 f-14">{{u.projecaoRelativa | number:'2.2-2'}}%</span>
          <i *ngIf="u.crescimento < 0"  class="mdi mdi-arrow-down-bold-hexagon-outline text-danger f-26 ml-2"></i>
          <i *ngIf="u.crescimento == 0" class="mdi mdi-hexagon-outline text-warning f-26 ml-2"></i>
          <i *ngIf="u.crescimento > 0" class="mdi mdi-arrow-up-bold-hexagon-outline text-success f-26 ml-2"></i>
        </div>
      </div>

      <table *ngIf="u.show" class="table table-sm table-striped text-center">
        <thead class="bg-light">
          <tr>
            <th class="text-left">Consulta</th>
            <th>Mês anterior</th>
            <th>Projeção mês anterior</th>
            <th>Periodo selecionado</th>
            <th>Projeção mês atual</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of u.producao">
            <td class="text-left">{{c.nomeProduto}}</td>
            <td>{{c.qtdIntervalo1 | number:'1.0-0'}}</td>
            <td>{{c.projecaoIntervalo1 | number:'1.0-0'}}</td>
            <td>{{c.qtdIntervalo2 | number:'1.0-0'}}</td>
            <td>{{c.projecaoIntervalo2 | number:'1.0-0'}}</td>
            <td>
              <i *ngIf="c.status=='danger'" class="mdi mdi-close-circle text-danger f-22"></i>
              <i *ngIf="c.status=='warning'" class="mdi mdi-alert-circle text-warning f-22"></i>
              <i *ngIf="c.status=='success'" class="mdi mdi-check-circle text-success f-22"></i>
            </td>
          </tr>
          <tr>
            <th class="text-left">TOTAL</th>
            <th>{{u.qtdIntervalo1 | number:'1.0-0'}}</th>
            <th>{{u.projecaoIntervalo1 | number:'1.0-0'}}</th>
            <th>{{u.qtdIntervalo2 | number:'1.0-0'}}</th>
            <th>{{u.projecaoIntervalo2 | number:'1.0-0'}}</th>
            <th class="pointer py-0" (click)="u.show=false"><i class="mdi mdi-chevron-up text-muted f-28"></i></th>
          </tr>
      </table>

    </div>

  </ng-container>

</section>